module.exports = __webpack_public_path__ + "static/media/location.ca7b759e.svg";